import { render, staticRenderFns } from "./ProjectCostsTable.vue?vue&type=template&id=758f6a80&"
import script from "./ProjectCostsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectCostsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
installComponents(component, {VForm})
